import type { IconData } from '@stacksjs/iconify-core'

export const sailShip: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M4.619 41.084c-1.562-3.3-2.192-6.251-2.447-8.096C2.022 31.894 2.896 31 4 31h40c1.105 0 1.98.894 1.828 1.988c-.254 1.844-.884 4.795-2.446 8.096c-1.102 2.327-3.535 3.632-6.11 3.706c-3.374.096-8.384.21-13.272.21c-4.887 0-9.897-.114-13.272-.21c-2.574-.074-5.008-1.379-6.11-3.706M44.5 37h-41m4.68-16.192c2.59-4.683 7.27-12.276 12.839-17.392c1.192-1.094 2.98-.193 2.98 1.425v20.16H10.728c-2.199 0-3.611-2.269-2.547-4.193M29.5 25.017h7.814c2.189 0 3.61-2.249 2.582-4.18c-2.313-4.342-6.253-11.025-10.396-14.87M24 25v6\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default sailShip
